import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import Grid from '@material-ui/core/Grid';
import { Container } from '@material-ui/core';

const styles = {
    appBar: {
        position: 'relative',

    },
    container: {
        paddingTop: '50px',
        maxWidth:'90%',
    }
};

const Transition = React.forwardRef((props, ref) => {
    return <Slide direction="up" {...props} ref={ref}/>;
});

class FullScreenDialog extends React.Component {
    
    render() {
        const { classes } = this.props;
        return (
            <div>
                <Dialog
                    fullScreen
                    open={this.props.open}
                    onClose={this.props.close}
                    TransitionComponent={Transition}
                >
                    <AppBar className={classes.appBar} style={{ background: this.props.currentTheme.primary, color: this.props.currentTheme.color }}>
                        <Toolbar>
                            <Grid
                                container
                                direction="row"
                                justify="space-between"
                                alignItems="center"
                            >
                                <IconButton color="inherit" onClick={this.props.close} aria-label="Close">
                                    <CloseIcon />
                                </IconButton>
                                <Typography variant="h6" color="inherit">
                                    {this.props.title}
                                </Typography>
                                <div>
                                    {
                                        this.props.save ?
                                            (<Button color="primary" style={{ background: this.props.currentTheme.secondary, color: 'white', minWidth:"150px"}} onClick={this.props.onConfirm}>
                                                Save
                                            </Button>) : null
                                    }
                                </div>
                            </Grid>
                        </Toolbar>
                    </AppBar>
                    <Container className={classes.container}>
                        {this.props.children}
                    </Container>
                </Dialog>
            </div>
        );
    }
}

FullScreenDialog.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FullScreenDialog);
